(() => {
  document.querySelectorAll('[data-ll-pdp]').forEach(init);

  function init(root) {
    const $ = s => root.querySelector(s);
    const $$ = s => [...root.querySelectorAll(s)];
    const currency = root.dataset.currency || 'USD';
    const threshold = +root.dataset.threshold || 0;
    const clubPct = +root.dataset.clubPct || 100;
    let cartTotal = +root.dataset.cartTotal || 0;
    let qty = 1;

    const atc = $('[data-atc]');
    const mainCard = $('[data-match-card="main"]');
    const matchCard = $('[data-match-card="match"]');
    const note = $('[data-match-note]');
    const variantSelect = $('[data-variant-select]');

    const fmt = cents => new Intl.NumberFormat(undefined, {
      style: 'currency', currency,
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2
    }).format(cents / 100);

    const mainPrice = () => +atc.dataset.price;
    const mainOn = () => !mainCard || mainCard.classList.contains('is-on');
    const matchOn = () => !!matchCard && matchCard.classList.contains('is-on');
    const clubRadio = () => $('[data-purchase][value="club"]');
    const isClub = () => !!clubRadio()?.checked;

    function itemsCents() {
      return ((mainOn() ? mainPrice() : 0) + (matchOn() ? +matchCard.dataset.price : 0)) * qty;
    }

    function render() {
      const items = itemsCents();
      const member = Math.round(items * clubPct / 100);
      const shown = isClub() ? member : items;
      $('[data-price-display]').textContent = fmt(shown);
      const ml = $('[data-member-line]');
      if (ml) ml.textContent = isClub() ? 'Club price applied' : 'Members pay ' + fmt(member);
      const ot = $('[data-onetime-price]'); if (ot) ot.textContent = fmt(items);
      const ci = $('[data-club-item-price]'); if (ci) ci.textContent = fmt(member);
      const sp = $('[data-sticky-price]'); if (sp) sp.textContent = fmt(shown);
      const mcp = $('[data-main-card-price]'); if (mcp) mcp.textContent = fmt(mainPrice());
      $('[data-qty-value]').textContent = qty;
      if (!atc.disabled && !atc.dataset.busy) {
        atc.textContent = isClub()
          ? 'Join Club and add · ' + fmt(member + +clubRadio().dataset.clubPrice)
          : 'Add to cart · ' + fmt(items);
      }
      if (note) {
        const both = mainOn() && matchOn();
        note.textContent = both ? note.dataset.both : mainOn() ? note.dataset.single : note.dataset.only;
        note.classList.toggle('is-both', both);
      }
      if (threshold) {
        const total = cartTotal + shown;
        const left = Math.max(0, threshold - total);
        $('[data-ship-text]').textContent = left > 0 ? fmt(left) + ' away from free shipping' : 'Your order ships free';
        $('[data-ship-fill]').style.width = Math.min(100, total / threshold * 100) + '%';
      }
    }

    function toggleCard(card, other) {
      if (!card) return;
      const on = card.classList.contains('is-on');
      if (on && other && !other.classList.contains('is-on')) {
        card.classList.remove('is-on'); other.classList.add('is-on');
      } else {
        card.classList.toggle('is-on');
      }
      [mainCard, matchCard].forEach(c => c && c.setAttribute('aria-pressed', c.classList.contains('is-on')));
      render();
    }
    mainCard?.addEventListener('click', () => toggleCard(mainCard, matchCard));
    matchCard?.addEventListener('click', () => toggleCard(matchCard, mainCard));

    $$('[data-purchase]').forEach(r => r.addEventListener('change', render));
    $$('[data-qty]').forEach(b => b.addEventListener('click', () => {
      qty = Math.min(20, Math.max(1, qty + +b.dataset.qty)); render();
    }));

    variantSelect?.addEventListener('change', () => {
      const opt = variantSelect.selectedOptions[0];
      atc.dataset.variant = opt.value;
      atc.dataset.price = opt.dataset.price;
      if (mainCard) { mainCard.dataset.variant = opt.value; mainCard.dataset.price = opt.dataset.price; }
      const url = new URL(location.href); url.searchParams.set('variant', opt.value);
      history.replaceState({}, '', url);
      render();
    });

    async function addToCart() {
      const items = [];
      if (mainOn()) items.push({ id: +atc.dataset.variant, quantity: qty });
      if (matchOn()) items.push({ id: +matchCard.dataset.variant, quantity: qty });
      if (isClub()) items.push({ id: +clubRadio().dataset.clubVariant, quantity: 1 });
      const err = $('[data-error]');
      err.hidden = true;
      atc.dataset.busy = '1'; atc.textContent = 'Adding…';
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Could not add to cart');
        if (root.dataset.afterAdd === 'cart') { location.href = (window.Shopify?.routes?.root || '/') + 'cart'; return; }
        const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
        cartTotal = cart.total_price;
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span:first-child').forEach(el => el.textContent = cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cart }));
        atc.textContent = 'Added to cart';
        setTimeout(() => { delete atc.dataset.busy; render(); }, 1800);
      } catch (e) {
        delete atc.dataset.busy; render();
        err.textContent = e.message; err.hidden = false;
      }
    }
    atc.addEventListener('click', addToCart);
    $('[data-atc-proxy]')?.addEventListener('click', addToCart);

    const sticky = $('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atc);
    }

    render();
  }
})();